import { userConstants, authConstants } from '../constants';
import { MessagesActions } from './';
import { redirect } from '../helper';
import { UserApi } from '../services';

export class UserActions {
    static register (data) {
        return (dispatch) => {
            dispatch({type: userConstants.REGISTER_REQUEST, payload: {...data}});

            UserApi.register(data)
                .then((res) => res.json())
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: userConstants.REGISTER_SUCCESS, payload: {...data}});
                        dispatch({type: authConstants.USER_LOGGED_IN, payload: {...data}})
                        redirect('./profile'); // redirect to profile page

                        const welcom = `
                            <strong>ברוכים הבאים!</strong><br />
                            להשלמת תהליך ההרשמה<br />
                            אנא עדכנו את מספר הטלפון והלוגו שלכם.<br />
                            לאחר מכן עברו
                            <a href="./" style="text-decoration: none"><strong>לדף הראשי</strong></a>
                        `;
                        dispatch(MessagesActions.pushInfo(welcom, {allowHTML: true, time: '60s', position: 'center'}));
                        return;
                    }

                    // error duplicate email
                    if(res.data && res.data.error && res.data.error.emailExists === true) {
                        return dispatch({type: userConstants.REGISTER_DUPLICATE_EMAIL, payload: {...data}})
                    }

                    // another validation error
                    return dispatch({type: userConstants.REGISTER_FAILURE, payload: {...data}});
                })
                .catch((err) => {
                    dispatch({type: userConstants.REGISTER_FAILURE, payload: {...data}});
                });
        }
    }

    static getData () {
        return (dispatch) => {
            dispatch({type: userConstants.GET_USER_DATA_REQEUST});

            UserApi.getData()
                .then((res) => {

                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: userConstants.GET_USER_DATA_SUCCESS, payload: {...res.data}});
                        return;
                    }

                    return dispatch({type: userConstants.GET_USER_DATA_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: userConstants.GET_USER_DATA_FAILURE});
                });
        }
    }

    static updateUser (data) {
        return (dispatch) => {
            dispatch({type: userConstants.UPDATE_USER_DATA_REQUEST});

            UserApi.updateUser(data)
                .then((res) => {

                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: userConstants.UPDATE_USER_DATA_SUCCESS, payload: {...res.data}});
                        dispatch(MessagesActions.pushSuccess('הפרופיל שלכם עודכן בהצלחה!'));
                        return;
                    }

                    dispatch(MessagesActions.pushError('הפרטים שהזנתם לא תקינים או כבר קיימים במערכת'));
                    return dispatch({type: userConstants.UPDATE_USER_DATA_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: userConstants.UPDATE_USER_DATA_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה במערכת אנא נסו שוב'));
                });
        }
    }

    static uploadLogo (file) {
        return (dispatch) => {
            dispatch({type: userConstants.UPLOAD_USER_LOGO_REQUEST});

            var formData = new FormData();
            formData.append('logo', file);

            UserApi.uploadLogo(formData)
                .then((res) => {
                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        var payload = {...res.data};
                        if(payload.url) payload.url += "?t=" + new Date().getTime(); // force update (in user view - prevent browser cache)
                        
                        dispatch({type: userConstants.UPLOAD_USER_LOGO_SUCCESS, payload: payload});
                        dispatch(MessagesActions.pushSuccess('הלוגו שלכם עודכן בהצלחה!'));
                        return;
                    }

                    dispatch(MessagesActions.pushError('העלאת הלוגו נכשלה אנא נסו שוב...'));
                    return dispatch({type: userConstants.UPLOAD_USER_LOGO_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: userConstants.UPLOAD_USER_LOGO_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה במערכת אנא נסו שוב'));
                });
        }
    }

    static deleteLogo () {
        return (dispatch) => {
            dispatch({type: userConstants.DELETE_USER_LOGO_REQUEST});

            UserApi.deleteLogo()
                .then((res) => {
                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: userConstants.DELETE_USER_LOGO_SUCCESS});
                        dispatch(MessagesActions.pushSuccess('הלוגו שלכם נמחק בהצלחה!'));
                        return;
                    }

                    dispatch(MessagesActions.pushError('מחיקת הלוגו נכלשה אנא נסו שוב...'));
                    return dispatch({type: userConstants.DELETE_USER_LOGO_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: userConstants.DELETE_USER_LOGO_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה במערכת אנא נסו שוב'));
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/user.js